export const linkedItem = kendo.data.Model.define({
  id: 'uid',
  fields: {
    Id: {
      type: 'number',
      editable: false
    },
    Category: {
      type: 'string',
      editable: false
    },
    Type: {
      type: 'string'
    },
    Name: {
      type: 'string'
    },
    EstimatedSalePrice: {
      type: 'number'
    },
    GmPercent: {
      type: 'number'
    }
  }
});

export const platform = kendo.data.Model.define({
  id: 'Id',
  fields: {
    Id: {
      type: 'number',
      editable: false
    },
    Name: {
      type: 'string',
      editable: false
    }
  }
});

export const estimateApprovalRow = kendo.data.Model.define({
  id: 'Id',
  fields: {
    Id: {
      type: 'number',
      editable: false
    },
    DisplayId: {
      type: 'string',
      editable: false
    },
    CreatedOn: {
      type: 'date',
      editable: false
    },
    CreatedBy: {
      type: 'string',
      editable: false
    },
    ProjectName: {
      type: 'string',
      editable: false
    },
    IsRejected: {
      type: 'bool',
      editable: false
    },
    RejectedBy: {
      type: 'string',
      editable: false
    },
    Approvals: {
      type: 'object',
      editable: false
    },
    PendingApprovals: {
      type: 'string',
      editable: true
    },
    Status: {
      type: 'string',
      editable: false
    }
  }
});